
import { Component, Prop } from 'vue-property-decorator';
import ModalView from '@/components/helper/modal-view.vue';
import ListBase from '@/lib/listbase';
import Employee from '@/store/entities/admin/employee';

@Component({
    components: { ModalView },
    watch: {
        value: function (val) {
            let obj = (this as any);
            obj.modalShow = val;
        },
        modalShow: function (val) {
            if (!val) {
                this.$emit('input', false);
            } else {
                (this as any).initForm();
            }
        }
    }
})

export default class EmployeeForm extends ListBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    employee: Employee = new Employee();
    modalShow: boolean = false;
    formBase: boolean = true;
    image: any = null;
    modalSetting: any = {
        entity: "employee",
        title: 'Empleado',
        width: "600px",
    };

    items = [
        this.gItem({ type: 'text', prop: 'fullname', label: 'Nombre Completo', size: 8, required: true }),
        this.gItem({ type: 'text', prop: 'code', label: 'DNI', size: 4, required: true }),
        this.gItem({ type: 'phone', prop: 'phone', label: 'Telefono', size: 6 }),
        this.gItem({ type: 'email', prop: 'email', label: 'Email', size: 6 }),
        this.gItem({ type: 'object', prop: 'dealer_id', label: 'Dealer', size: 8 }),
        this.gItem({ type: 'active', size: 4 }),
    ]


    initForm() {
    }

    async save() {
        this.$emit('save-success');
        this.$emit('input', false);
    }

    cancel() {
        this.$emit('input', false);
    }

    mounted() {
    }

    created() {
    }
}
